module.exports = __webpack_public_path__ + "static/media/genitive_of_comparison_img.b43c8d9b.JPG";